export const isUrl = (stringToBeValidated: string) => {
  if (stringToBeValidated.trim() === "") return false;
  try {
    new URL(stringToBeValidated);
    return true;
  } catch {
    return false;
  }
};
